import React, { useState, useEffect } from "react";
import { DRAWER_GRADIENT } from "../../../constants/colors";
import MetricKpiBoxSmall from "../../../components/MetricKpiBoxSmall";
import BlockStackBarList from "../../../components/BlockStackBarList";
import AmChartTreemap from "../../../components/AmChartTreemap";
import useSpaceOrgDashboardBuilding from "../hooks/useSpaceOrgDashboardBuilding";


export default function BuildingDrawer({
    showFilter,
    expanded,
    onToggle,
	facilityId,
	setSelectedFloorId
})
{
    const {
        kpis,
        spaceBreakdown,
        topBuildings,
        buildingBreakdown,
        selectedBuilding,
        topFloors
    } = useSpaceOrgDashboardBuilding(facilityId);

    const drawer =
    {
        position: "absolute",

        display: "flex",
        flexDirection: "column",

        top: "0px",
        left: "0px",
        bottom: "0px",

        width: "390px",

        background:
            DRAWER_GRADIENT,
			
			transform:
			    expanded
			        ? "translateX(-410px)"
			        : "translateX(0px)",

        boxShadow:
            expanded
                ? "none"
                : "0 20px 40px rgba(0,0,0,0.45)",

        padding:
            expanded
                ? "0px"
                : "20px",

        overflow: "hidden",

        transition:
            "all 0.3s ease",

        zIndex: 1000
    };

    const drawerTitle =
    {
        color: "#ffffff",
        fontSize: "16px",
        fontWeight: "plain",
        marginBottom: "20px"
    };
	
	function getKpiValue(code)
	{
	    if(!kpis)
	    {
	        return "0";
	    }

	    for(let i = 0; i < kpis.length; i++)
	    {
	        if(kpis[i].code === code)
	        {
	            return Number(
	                kpis[i].value
	            ).toLocaleString();
	        }
	    }

	    return "0";
	}
	
	const handleFloorClick = (obj) => {
	  if(setSelectedFloorId){
		setSelectedFloorId(obj);
	  }
	}

    return (
        <div style={drawer}>

            {/* KPI SECTION */}

            <div
                style={{
                    marginTop: "10px"
                }}
            >

                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "10px"
                    }}
                >
				<MetricKpiBoxSmall
				    value={
				        getKpiValue(
				            "AREA"
				        )
				    }
				    label="Area"
				/>

				<MetricKpiBoxSmall
				    value={
				        getKpiValue(
				            "CAPACITY"
				        )
				    }
				    label="Capacity"
				/>

				<MetricKpiBoxSmall
				    value={
				        getKpiValue(
				            "SPACES"
				        )
				    }
				    label="Spaces"
				/>

				<MetricKpiBoxSmall
				    value={
				        getKpiValue(
				            "FLOORS"
				        )
				    }
				    label="Floors"
				/>
                </div>

                <div
                    style={{
                        padding: "20px",
                        marginTop: "10px"
                    }}
                >
                    <BlockStackBarList
                        title="Top Floors"
                        rows={topFloors}
						onSelect={handleFloorClick}
                    />
                </div>

            </div>

            {/* PUSH TREEMAP TO BOTTOM */}

            <div
                style={{
                    marginTop: "auto"
                }}
            >

                <div
                    style={{
                        color: "#ffffff",
                        fontSize: "16px",
                        marginBottom: "10px"
                    }}
                >
                    Space Type Breakdown
                </div>

                <AmChartTreemap
                    chartId="spaceDashboardTreemap"
                    width="100%"
                    height="250px"
                    chartData={spaceBreakdown}
                    valueColumn="area"
                    nameColumn="description"
                    childrenColumn="children"
                    onClick={function(item)
                    {
                        console.log(item);
                    }}
                />

            </div>

        </div>
    );
}


